import React from 'react';
import { Select } from 'evergreen-ui';
import { useGetRegionsFGBUQuery } from 'Services/api/regionsApi';
import { DictionaryType } from 'helper/types';
import { getDisabledSelect, getNotSelectedValueLabel } from '../../Filters/utils';
import {RegionFGBUType, RegionSelectProps} from "../../Filters/RegionSelect";

/**
 * Выбор regionId для station.
 * * Регионы грузятся с сервера
 * * При выборе региона возвращается выбранный регион и массив сопутствующих регионов.
 * * При первой отрисовке с наличием `selected` происходит автоматический `onSelect` с выбранными регионами.
 * @returns
 */
export function RegionSelectMonitoring({ selected, onSelect, onChange }: RegionSelectProps) {
    // угмс с вложенными цгмс (regionsCGMS) id уникален (нет такого id цгмс, который бы был у угмс и наоборот)
    const { data, isLoading } = useGetRegionsFGBUQuery(undefined);
    const regionsData = (data || []) as RegionFGBUType[];
    const [firstSelect, setFirstSelect] = React.useState(true);

    // ! нужно что-то с этим делать? это нужно только в отчетах,
    // TODO: так что доп фильтры регионов могут приходить из props или вообще сделать опять
    // же чисто отрисовку и хуки
    // const filterRegions = useSelector(filterRegionsSelector);
    // const filterRegions = React.useMemo(() => regionIds.filter((r) => userInfo?.acl?.regions[r].includes('A')), [regionIds, userInfo]);

    const { disabledSelect, notSelectedValueLabel } = React.useMemo(() => {
        return {
            notSelectedValueLabel: getNotSelectedValueLabel({ isLoading, dataLength: regionsData.length, label: 'ВСЕ РЕГИОНЫ', noDataLabel: 'Нет регионов' }),
            disabledSelect: getDisabledSelect({ isLoading, dataLength: regionsData.length }),
        };
    }, [isLoading, regionsData.length]);

    /** вспомогательный объект, где ugms id принадлежит массив с cgms ids */
    const regionIds = React.useMemo(() => {
        return regionsData.reduce((acc, ugmsRegion) => {
            if (ugmsRegion.regionsCGMS?.length > 0) {
                acc[ugmsRegion.id] = ugmsRegion.regionsCGMS.map(({ id: cgmsId }) => cgmsId);
            } else {
                acc[ugmsRegion.id] = [];
            }
            return acc;
        }, {} as DictionaryType<number[]>);
    }, [regionsData]);

    // ! а надо ли оно ??? !delete ????
    // установка при первой отрисовке выбранных айди регионов в зависимости от `selected`
    React.useEffect(() => {
        if (onSelect && firstSelect) {
            if (selected || selected === 0) onSelect(selected, [selected, ...(regionIds[selected] || [])]);
            setFirstSelect(false);
        }
    }, [firstSelect, onSelect, regionIds, selected]);

    /** при выборе УГМС будет браться список всех его ЦГМС и сам УГМС */
    const onChangeRegion = React.useCallback((event:React.ChangeEvent<HTMLSelectElement>) => {
        const regionId = event.target.value;
        if (regionId === '-1') {
            onSelect && onSelect(undefined);
        } else {
            onSelect && onSelect(+regionId, [+regionId, ...(regionIds[regionId] || [])]);
        }
        onChange && onChange(event);
    }, [onChange, onSelect, regionIds]);

    return (
        <Select value={selected ?? -1} onChange={onChangeRegion} disabled={disabledSelect}>
            <option value={-1}>{notSelectedValueLabel}</option>
            {
                regionsData?.map(({ id, name, regionsCGMS }) => {
                    return (
                        <React.Fragment key={id}>
                            <option value={id}>{name}</option>
                            {
                                regionsCGMS && regionsCGMS?.length > 0
                                    ? (
                                        <optgroup label="ЦГМС">
                                            {
                                                regionsCGMS?.map((regionCgms) => (
                                                    <option key={regionCgms.id} value={regionCgms.id}>
                                                        {regionCgms.name}
                                                    </option>
                                                ))
                                            }
                                        </optgroup>
                                    )
                                    : null
                            }
                        </React.Fragment>
                    );
                })
            }

        </Select>
    );
}
export const MemoRegionSelectMonitoring = React.memo(RegionSelectMonitoring);
MemoRegionSelectMonitoring.displayName = 'MemoRegionSelectMonitoring';
export default RegionSelectMonitoring;
